<template>
  <div v-if="ctlProducts.length" class="complete-the-look">
    <div class="complete-the-look__header">
      <h3 class="complete-the-look__title">Complete The Look</h3>
    </div>

    <div class="complete-the-look__swiper-container swiper-container" ref="productSlider">
      <div class="complete-the-look__swiper">
        <div
          class="complete-the-look__swiper-slide"
          v-for="(product, idx) in ctlProducts"
          :key="`${product.product?.handle || idx}-${product.selectedFirstOption || ''}`"
        >
          <ProductCard type="TypeF" :product="product" :showWishlistIcon="false" />
        </div>
      </div>

      <div class="complete-the-look__swiper-nav complete-the-look__prev">
        <svg class="complete-the-look__prev-icon">
          <use xlink:href="#icon-prev"></use>
        </svg>
      </div>
      <div class="complete-the-look__swiper-nav complete-the-look__next">
        <svg class="complete-the-look__next-icon">
          <use xlink:href="#icon-next"></use>
        </svg>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { computed, onMounted, onUpdated, ref, toRefs, watch } from 'vue';
  import ProductCard from '../../global/product-card/index.vue';
  import Swiper from 'swiper';
  import SwiperCore, { Navigation, EffectFade, Thumbs, Pagination, A11y } from 'swiper/core';

  SwiperCore.use([Navigation, EffectFade, Thumbs, Pagination, A11y]);

  const props = defineProps({
    ctlProducts: {
      type: Object,
      default: () => ({}),
    },
  });

  const { ctlProducts } = toRefs(props);
  const productSlider = ref(null);
  const swiperInstance = ref(null);

  onMounted(() => {
    initializeSwipers();
  });

  const productCarousel = computed(() => {
    return {
      slidesPerView: 1.72,
      spaceBetween: 18,
      wrapperClass: 'complete-the-look__swiper',
      slideClass: 'complete-the-look__swiper-slide',
      threshold: 6, // will get swiped only when drag is atleast 6px
      watchSlidesProgress: true,
      breakpoints: {
        768: {
          slidesPerView: 2.3,
          spaceBetween: 18,
        },
        1440: {
          slidesPerView: 3,
          spaceBetween: 18,
        }
      },
      a11y: {
          enabled: true,
      },
      navigation: {
        nextEl: '.complete-the-look__next',
        prevEl: '.complete-the-look__prev',
      },
    };
  });

  const initializeSwipers = () => {
    if (ctlProducts.value.length > 0) {
      swiperInstance.value = new Swiper(productSlider.value, productCarousel.value);
    }
  };

  watch(ctlProducts, () => {
    setTimeout(() => {
      if (swiperInstance.value?.destroy) {
        swiperInstance.value.destroy();
      }
      initializeSwipers();
    }, 100);
  });
</script>
